import { rgba } from 'polished';
import { PalletteProps } from '../../../types/theme/pallette';
import styled from 'styled-components';

interface CustomElement extends PalletteProps {
  isSelected: boolean;
}

export const TimeElement = styled.button`
  border-radius: 8px;
  border: ${({ theme, isSelected }: CustomElement) =>
    isSelected ? `solid 1px ${(theme.successColor)}` : `1px dashed ${(theme.gray4)}`};
  background: ${({ isSelected, theme, disabled }) => 
      disabled ? theme.lightGray : (isSelected ? rgba(theme.successColor, 0.15) : '')};
  padding: 10px 20px;
  transition: all 0.3s ease-in-out, color 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

export const TimeText = styled.p`
  color: ${({ isSelected, theme }: CustomElement) =>
    isSelected ? theme.gray2 : theme.gray3};
  font-size: 1rem;
  font-weight: 'normal';
  flex: 1;
`;
